<template>
  <div :class="componentClass"></div>
</template>

<script>
import isString from 'lodash/isString';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';

import Vue from 'vue';
import toastr from 'toastr';
import { Bus } from '../bus';

export default Vue.extend({
  name: 'AlertComponent',
  props: {
    title: {
      type: String,
      default: '',
    },
    payload: {},
    type: {
      type: String,
      default: 'info',
    },
    offsetTop: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    componentClass() {
      const componentClass = 'Alert';

      return componentClass;
    },
    parsedTitle() {
      if (!this.payload) {
        return null;
      }

      if (isString(this.payload)) {
        return null;
      }

      return this.payload.title;
    },
    parsedMessage() {
      if (!this.payload) {
        return null;
      }

      if (isString(this.payload)) {
        return this.payload;
      }

      return this.payload.message;
    },
  },
  methods: {
    alert(type, alert) {
      let title = '';
      let message = '';

      if (isString(alert)) {
        title = null;
        message = alert;
      } else {
        title = alert.title;
        message = alert.message;
      }

      if (type === 'danger') {
        // eslint-disable-next-line no-param-reassign
        type = 'error';
      }

      if (type === 'message') {
        // eslint-disable-next-line no-param-reassign
        type = 'info';
      }

      toastr[type](message, title, {
        newestOnTop: true,
        closeButton: true,
        timeOut: 3000,
        showDuration: 0,
        hideDuration: 0,
        positionClass: `toast-top-right ${this.offsetTop === 1 ? 'mt-56px' : ''}`,
        progressBar: false,
        extendedTimeOut: 3000,
        tapToDismiss: true,
      });
    },
    emitAlerts(alerts) {
      if (alerts && isString(alerts)) {
        return this.alert('info', alerts);
      }

      if (alerts && isObject(alerts)) {
        const alertTypes = ['message', 'info', 'success', 'warning', 'error', 'danger'];

        alertTypes.forEach((alertType) => {
          if (alerts[alertType]) {
            if (isArray(alerts[alertType])) {
              alerts[alertType].forEach((alert) => {
                this.alert(alertType, alert);
              });
            } else {
              this.alert(alertType, alerts[alertType]);
            }
          }
        });
      }

      return null;
    },
    emitErrors(alerts) {
      if (alerts && isString(alerts)) {
        return this.alert('error', alerts);
      }

      Object.keys(alerts.errors).forEach((label) => {
        this.alert('error', alerts.errors[label].join(' '));
      });

      return null;
    },
  },
  mounted() {
    if (this.payload) {
      this.alert(this.type, {
        title: this.parsedTitle,
        message: this.parsedMessage,
      });
    }

    Bus.$on('alert', this.emitAlerts);
    Bus.$on('error', this.emitErrors);
  },
  destroyed() {
    Bus.$off('alert');
    Bus.$off('error');
  },
});
</script>
